import CrifAnalysisService from 'app/services/CrifAnalysisService';
import BaseAnalysisFindPageMixin from 'app/mixins/BaseAnalysisFindPageMixin';

export default {
  mixins: [ BaseAnalysisFindPageMixin ],

  data() {
    return {
      service: CrifAnalysisService,
      label: 'Analisi Crif',
      filtersComponent: 'crif-analysis-filters',
      loadPage: 'CrifAnalysis',
      clonePage: 'CrifAnalysisClone',
    };
  },
}
